export default __webpack_public_path__ + "static/media/dish1.e54ccfb2.svg";